import React, { ReactNode } from 'react';
import './styles.scss';

interface RadioProps {
  label: string | ReactNode;
  checked?: boolean;
  onChange: () => void;
  disabled?: boolean;
  className?: string;
  rightIcon?: ReactNode;
}

export const Radio: React.FC<RadioProps> = ({
  label,
  checked,
  onChange,
  className,
  disabled = false,
  rightIcon,
}) => {
  const handleOnChange = () => {
    if (disabled) return;

    onChange();
  };

  return (
    <div className={`radio-container ${className || ''}`}>
      <input type="radio" className="hidden-radio" checked={checked} onChange={handleOnChange} />
      <div className="radio-content" onClick={handleOnChange}>
        <div className={`styled-radio ${checked ? 'checked' : ''}`}></div>
        <label className={`radio-label ${disabled && 'radio-label-disabled'}`}>{label}</label>
        {rightIcon}
      </div>
    </div>
  );
};
